import { useEffect } from 'react';
import { useAttributionAdvertiserQueries } from './AttributionAdvertiserQueries';
import { useAttributionPageContext } from './useAttributionPage';
import { Performance } from '../types/CampaignPerformance';

const useAttributionAdvertiser = (): void => {
    const {
        attributionCriteria,
        attributionDate,

        setPerformances,
        setPreviousPerformances,

        setIsFetchingPerformances,
        setIsFetchingPreviousPerformances,

        setAmcReachAndFrequencyList,
        setIsFetchingAmcReachAndFrequencyList,

        setPreviousAmcReachAndFrequencyList,
        setIsFetchingPreviousAmcReachAndFrequencyList,
    } = useAttributionPageContext();

    const {
        currentPerformanceQuery,
        previousPerformanceQuery,
        currentReachFrequencyQuery,
        previousReachFrequencyQuery,
    } = useAttributionAdvertiserQueries(attributionCriteria, attributionDate);

    const { data: rawCurrentPerformances = [], isFetching: isFetchingCurrentPerformances } = currentPerformanceQuery;
    const { data: rawPreviousPerformances = [], isFetching: isFetchingPreviousPerformances } = previousPerformanceQuery;

    const { data: currentReachFrequencies = [], isFetching: isFetchingCurrentAmcReachAndFrequencyList } =
        currentReachFrequencyQuery;
    const { data: previousReachFrequencies = [], isFetching: isFetchingPreviousAmcReachAndFrequencyList } =
        previousReachFrequencyQuery;

    // Setup: List of Campaign Performance

    useEffect(() => {
        setPerformances((rawCurrentPerformances || []).map((v) => v as unknown as Performance));
    }, [setPerformances, rawCurrentPerformances]);

    useEffect(() => {
        setPreviousPerformances((rawPreviousPerformances || []).map((v) => v as unknown as Performance));
    }, [setPreviousPerformances, rawPreviousPerformances]);

    useEffect(() => {
        setIsFetchingPerformances(isFetchingCurrentPerformances);
    }, [setIsFetchingPerformances, isFetchingCurrentPerformances]);

    useEffect(() => {
        setIsFetchingPreviousPerformances(isFetchingPreviousPerformances);
    }, [setIsFetchingPreviousPerformances, isFetchingPreviousPerformances]);

    // Setup: List of AMC Reach and Frequency

    useEffect(() => {
        setAmcReachAndFrequencyList(currentReachFrequencies);
    }, [setAmcReachAndFrequencyList, currentReachFrequencies]);

    useEffect(() => {
        setPreviousAmcReachAndFrequencyList(previousReachFrequencies);
    }, [setPreviousAmcReachAndFrequencyList, previousReachFrequencies]);

    useEffect(() => {
        setIsFetchingAmcReachAndFrequencyList(isFetchingCurrentAmcReachAndFrequencyList);
    }, [setIsFetchingAmcReachAndFrequencyList, isFetchingCurrentAmcReachAndFrequencyList]);

    useEffect(() => {
        setIsFetchingPreviousAmcReachAndFrequencyList(isFetchingPreviousAmcReachAndFrequencyList);
    }, [setIsFetchingPreviousAmcReachAndFrequencyList, isFetchingPreviousAmcReachAndFrequencyList]);
};

export { useAttributionAdvertiser };
